import apiCall from './apiCall';

export const getShop = async () => {
  const resp = await apiCall('GET', '/shop', {}, {size:1});

  return resp.data;
}
